import { Link } from "react-router-dom";

export default function NotFound() {
    return (
        <div className="container text-center py-5">
            <h1 className="display-3 fw-bold">404</h1>
            <p className="lead">Page Not Found</p>

            <Link to="/" className="btn btn-primary mt-3">
                Back to Home
            </Link>
        </div>
    );
}